export const hideErrorOverlay = () => {
  import('./hideErrorOverlay.css').catch(() => {
    console.warn('Failed to load hideErrorOverlay.css')
  })
  console.info('Cypress detected, disabling React Error Overlay')
}
